const A = (f) => `/img/menu-art/${f}.png`;
const it = (name, desc) => (desc ? { name, desc } : { name });

// Contenido tomado de "menu amadeus restaurante.pdf" (sin precios)
export const MENU_COMPLETO = [
  {
    key: "cafe",
    title: "Nuestros Cafés",
    de: "Unser Kaffee",
    art: A("cafe-taza"),
    note: "✻ Pregunta por nuestra opción con leche vegetal ✻",
    groups: [
      {
        title: "Nuestros Cafés",
        items: [
          it("Café Amadeus", "Combinación de rompope, café y crema batida"),
          it("Café Mozart", "Delicioso café aromatizado con chocolate y crema batida"),
          it("Frapuchino", "Con crema batida"),
          it("Capuchino Helado"),
          it("Capuchino de Sabor", "Crema irlandesa, amaretto, avellana, menta, vainilla"),
          it("Café Vienés", "Aromático café con crema batida"),
          it("Capuchino"),
          it("Express Cortado"),
          it("Express"),
          it("Express Doble"),
          it("Express Doble Cortado"),
          it("Café Estilo Europeo"),
          it("Americano o Descafeinado"),
          it("Café Macchiato"),
          it("Café con Leche"),
          it("Flat White"),
          it("Affogato", "Express con helado de vainilla"),
        ],
      },
    ],
  },
  {
    key: "te",
    title: "Tés y Tisanas",
    de: "Tee",
    art: A("cafetera"),
    groups: [
      {
        title: "Tés y Tisanas",
        items: [
          it("Té Gourmet", "Deléitese con nuestro servicio de sabores gourmet acompañado con 3 galletas Amadeus"),
          it("Té Artístico", "Sorpréndase de su delicadeza, sabor y estética"),
          it("Té Chaí Frío o Caliente", "Mezcla de especias de la casa"),
          it("Té Sabores Clásicos"),
          it("Té Europeo"),
          it("Té Helado"),
          it("Té Helado Especial", "Fabulosa combinación de té negro, nieve de limón y fruta. ¡Disfrútelo!"),
          it("Té Matcha", "Caliente o frío"),
        ],
      },
    ],
  },
  {
    key: "leche",
    title: "Leche y Chocolate",
    de: "Milch & Schokolade",
    art: A("cafe-taza"),
    groups: [
      {
        title: "Leche y Chocolate",
        items: [
          it("Chocolate Vienés", "Delicioso chocolate con crema batida"),
          it("Chocolate Europeo", "Al estilo del Rey de España"),
          it("Malteada"),
          it("Chocolate Helado"),
          it("Leche Caliente o Fría"),
          it("Chocolate Caliente o Frío"),
          it("Chocolate Amadeus", "Delicioso chocolate aromatizado con licor de naranja"),
        ],
      },
    ],
  },
  {
    key: "bebidas",
    title: "Bebidas",
    de: "Getränke",
    groups: [
      {
        title: "Bebidas",
        items: [
          it("Limonada, Naranjada, Toronjada"),
          it("Jarra de Limonada", "Chica o grande"),
          it("Jarra de Preparado", "Chica o grande"),
          it("Smoothie Verde", "Manzana, espinaca, piña, apio, frappé"),
          it("Smoothie de Frutas"),
          it("Jugos"),
          it("Jugo Verde o Naranja con Papaya"),
          it("Refrescos 355 ml"),
          it("Coca Flotante", "Refresco de cola con una bola de nieve de limón"),
          it("Coca Amadeus", "Refresco de cola con una bola de helado de vainilla"),
          it("Agua Embotellada 500 ml"),
          it("Cerveza sin alcohol 355 ml"),
        ],
      },
      {
        title: "Sugerencias",
        items: [
          it("Preparado del Caribe", "Bebida tropical a base de piña y menta"),
          it("Limonada de Jengibre hecha en casa"),
          it("Lassi", "Bebida oriental que combina mango con yogurt y un toque de cardamomo"),
          it("Malteada al Orange", "Jugo de naranja, helado de vainilla y un toque de jarabe de amaretto"),
          it("Café Alas de Ángel", "Delicioso café aromatizado con crema irlandesa, leche y crema batida"),
          it("Café Vivaldi", "Café aromatizado con rompope y chocolate, con un poco de leche y crema batida"),
          it("Ponche Alemán", "Bebida fría de té verde con cassis y un toque de limón, acompañada con manzana finamente picada y zarzamora natural"),
        ],
      },
    ],
  },
  {
    key: "desayunos",
    title: "Desayunos",
    de: "Frühstück",
    art: A("desayuno"),
    note: "En Café Amadeus usamos huevo orgánico para preparar nuestros desayunos. Durante el desayuno, la mermelada que disfruta está hecha en casa con ingredientes 100% naturales.",
    groups: [
      {
        title: "Especialidades",
        items: [
          it("Bauernfrühstück (Desayuno Campesino)", "Tradicional platillo alemán, preparado con papa, tocino y huevo"),
          it("Huevos con Rajas", "Estrellados, bañados con rajas y gratinados"),
          it("Huevos Endiablados", "Huevos estrellados en salsa de tomate al vino tinto con tocino"),
          it("Huevos Ahogados en Nopales"),
          it("Omelette Poblano", "Relleno de flor de calabaza y bañado con salsa poblana"),
          it("Huevos Oaxaqueños", "Una combinación de salsa de frijol con mole, servido con queso, cebolla y totopos"),
          it("Huevos con Machaca"),
          it("Huevos en su Nido", "Huevos estrellados en un nido de tortillas con salsa verde en una cama de flor de calabaza"),
          it("Huevos Motuleños"),
          it("Huevos Benedictina", "Huevos poché gratinados con espinacas, tiras de jamón y queso, cubiertos de crema holandesa, acompañados de rodajas de jitomate"),
          it("Chilaquiles Azteca", "Totopo bañado en salsa poblana, gratinados con huitlacoche y champiñones"),
        ],
      },
      {
        title: "Algo Ligero",
        items: [
          it("Cocktail de Frutas"),
          it("Plato de Fruta de Temporada", "Chico o grande"),
          it("Plato de Fruta Especial", "Con yogurt, granola o cottage. Chico o grande"),
          it("Suprema de Toronja"),
          it("Omelette de la Casa", "Claras de huevo rellenas con nopal asado, gratinado con queso panela y cilantro"),
          it("Bowl de Yogurt", "Yogurt griego con granola Amadeus, kiwi, plátano, fresa, blueberry, chía, miel y mermelada de la casa"),
        ],
      },
      {
        title: "Los Clásicos",
        items: [
          it("Huevos Rancheros"),
          it("Huevos Albañil"),
          it("Huevos con Chistorra o Chorizo"),
          it("Huevos al Gusto", "Jamón, tocino o a la mexicana"),
          it("Huevos Naturales", "Tibios, revueltos o estrellados"),
          it("Omelette", "De champiñón o a las hierbas"),
          it("Chilaquiles", "Verdes, rojos o divorciados. Con 1 huevo, con 2 huevos, con pollo o con carne asada"),
        ],
      },
      {
        title: "Algo Dulce",
        items: [
          it("Pan Francés Relleno", "Con queso quark sobre un espejo de salsa de frutas"),
          it("Pan Dulce"),
          it("Pan Francés"),
          it("Hot Cakes"),
          it("Hot Cakes con Jamón o Tocino"),
          it("Avena Horneada", "Saludable y delicioso pastelillo de avena con blueberry y almendras, decorado con fresa fresca, kiwi y salsa de frutas, ideal para el desayuno"),
        ],
      },
    ],
  },
  {
    key: "antojitos",
    title: "Antojitos Mexicanos",
    de: "Mexikanische Spezialitäten",
    art: A("sarten"),
    groups: [
      {
        title: "Antojitos Mexicanos",
        items: [
          it("Enchiladas de la Casa", "Rellenas de pollo, bañadas con salsa verde y gratinadas"),
          it("Enchiladas Queretanas", "Rellenas con queso panela, acompañadas de papa y zanahoria"),
          it("Enchiladas Queretanas con Carne Asada", "170 gr. en crudo y 2 piezas de enchiladas"),
          it("Tostadas de Pollo"),
          it("Tacos de Pollo"),
          it("Quesadillas"),
          it("Sincronizadas"),
          it("Molletes", "2 piezas acompañados con pico de gallo. Con jamón o tocino, o con chistorra"),
          it("Quesadillas de Camembert", "Con pera y salsa borracha verde. Exquisita combinación en la que se unen sabores clásicos mexicanos y europeos, en un exquisito y único platillo"),
          it("Dobladitas de Chile Ancho", "Triángulos de tortilla de maíz rellena de frijol, chorizo y chile ancho. Bañadas en salsa de jitomate, aguacate, queso y chorizo"),
          it("Quesadillas Primavera", "Crujiente tortilla de harina rellena de frijol, pollo, cebolla y queso, servida con una rica ensalada de jícama y zanahoria rallada, acompañada con aderezo de chipotle"),
          it("Queso Fundido"),
          it("Queso Fundido con Chistorra"),
          it("Queso Panela Gratinado"),
        ],
      },
    ],
  },
  {
    key: "tortas",
    title: "Tortas y Sándwiches",
    de: "Sandwiches",
    art: A("pan-tostado"),
    groups: [
      {
        title: "Tortas y Sándwiches",
        items: [
          it("Torta de Salami con Queso Gruyere"),
          it("Torta Selva Negra", "Jamón ahumado tipo selva negra con salsa tártara"),
          it("Torta de Pollo Especial", "Pechuga de pollo asada, acompañada con germen, piña, aguacate y bañada con salsa de curry"),
          it("Club Sándwich"),
          it("Cuernito Relleno"),
          it("Sándwich de Jamón y Queso"),
          it("Sándwich Horneado", "Deliciosa combinación de pan tostado y jamón selva negra, bañado con salsa de queso gruyere. Acompañado con jitomate y aceite de olivo"),
          it("Torta de Lomo", "Exquisita torta de lomo de cerdo asado, con aderezo de chipotle. Acompañada con alcaparra frita con tocino"),
          it("Torta de Pollo al Chipotle", "Combinación de pechuga marinada al cilantro y chipotle con mango en almíbar, pimiento morrón y pico de gallo. Gratinada"),
        ],
      },
    ],
  },
  {
    key: "pastas",
    title: "Pastas",
    de: "Nudeln",
    art: A("plato"),
    groups: [
      {
        title: "Pastas",
        items: [
          it("Lasagna"),
          it("Pasta al Chipotle", "Con pollo asado"),
          it("Pasta a la Trucha Ahumada", "Fettuccine en salsa de jitomate con trucha ahumada"),
          it("Pasta Pesto", "En salsa cremosa de pesto con piñón, albahaca y parmesano"),
        ],
      },
    ],
  },
  {
    key: "ensaladas",
    title: "Ensaladas",
    de: "Salate",
    art: A("ensalada"),
    note: "Las ensaladas Vivaldi y Campesina también pueden pedirse con pechuga de pollo.",
    groups: [
      {
        title: "Ensaladas",
        items: [
          it("Amadeus", "Lechuga romana acompañada con germen, jitomate, aderezo de albahaca, tocino, granos de elote, aguacate y crujientes crotones"),
          it("Espinaca", "Espinacas frescas acompañadas con tiras de pechuga de pollo a la plancha, tocino, nuez y aderezo de curry, 170 gr. en crudo"),
          it("Húngara", "Lechuga italiana con pimientos, acompañada de pollo, atún, cebolla, jícama, aderezada con vinagreta"),
          it("Vivaldi", "Lechuga italiana con manzana fresca, nuez, piña y aderezo de amapola"),
          it("Roquefort", "Lechuga italiana, manzana fresca, jitomate, nuez y aderezo de roquefort"),
          it("Manzana", "Frescas manzanas acompañadas con queso, nuez, arándanos, crema y un toque de piña en almíbar"),
          it("Salmón", "Salmón ahumado, lechuga italiana, betabel y manzana, acompañada con aderezo de yogurt"),
          it("Campesina", "Lechuga italiana, fresa, queso de cabra, arándanos, pepino y semilla de girasol, aderezada con miel de agave y balsámico"),
        ],
      },
    ],
  },
  {
    key: "sopas",
    title: "Sopas",
    de: "Suppen",
    art: A("olla"),
    groups: [
      {
        title: "Sopas",
        items: [
          it("Reyna", "Deliciosa crema con espárragos, pollo desmenuzado y almendra tostada"),
          it("Champiñones"),
          it("Tortilla"),
          it("Consomé de Pollo con Arroz"),
          it("Badische Zwiebelsuppe", "Sopa de cebolla estilo alemán"),
          it("Gulaschsuppe", "Sopa de carne con paprika y pimiento morrón"),
          it("Crema de Brócoli", "Deliciosa y reconfortante combinación con trozos de aguacate y pan de ajo gratinado"),
        ],
      },
    ],
  },
  {
    key: "ninos",
    title: "Para los Niños",
    de: "Kindermenü",
    groups: [
      {
        title: "Kindermenü",
        items: [
          it("Jugo Chico"),
          it("Perlas de Fruta"),
          it("Hot Cakes"),
          it("Consomé de Pollo Chico"),
          it("Plato Infantil"),
          it("Pasta con Jamón y Queso"),
          it("Burritos"),
          it("Tiras de Pollo", "Servidas con papas o ensalada"),
        ],
      },
    ],
  },
  {
    key: "fuertes",
    title: "Platos Fuertes",
    de: "Hauptspeisen",
    art: A("plato"),
    note: "Pregunta por nuestras medias órdenes. No todos los platillos se pueden preparar en media orden. Gracias por su comprensión.",
    groups: [
      {
        title: "Platos Fuertes",
        items: [
          it("Milanesa Cazador", "180 gr. en crudo"),
          it("Geschnetzeltes (Puntas Alemanas)", "180 gr. en crudo"),
          it("Puntas a la Mexicana", "180 gr. en crudo"),
          it("Pechuga Almendrada", "180 gr. en crudo, empanizada y bañada en durazno y almendra fileteada, acompañada de arroz y ensalada verde"),
          it("Pollo Marsella", "Pechuga con hueso 560 gr. o pierna y muslo de pollo 370 gr. en crudo. Horneados con ciruelas, cebolla y aceitunas, acompañado de fettuccine"),
          it("Pechuga a la Plancha", "Pechuga de pollo 170 gr. en crudo a la plancha, con verduras cocidas y arroz"),
          it("Filete de Pescado a las Finas Hierbas", "Empanizado y gratinado, 170 gr. en crudo"),
          it("Trucha Ahumada", "Filete de trucha ahumada 180 gr. en crudo, acompañada con espárragos y papa con mantequilla. Servida fría o caliente"),
        ],
      },
    ],
  },
  {
    key: "alemana",
    title: "Cocina Alemana",
    de: "Deutsche Speisen",
    art: A("pan-tostado"),
    groups: [
      {
        title: "Platillos de la Cocina Alemana",
        items: [
          it("Wiener Schnitzel", "Milanesa de ternera, 180 gr. en crudo, empanizada, acompañada de ensalada de papa"),
          it("Pfannfisch", "Filete de pescado 170 gr. en crudo sobre una cama de papa campesina, bañado en una rica salsa con un toque de mostaza"),
          it("Beef Stroganoff", "Tiras de res, 170 gr. en crudo, bañadas en cremosa salsa de champiñones con cebolla cambray"),
          it("Coctel de Arenque", "Clásico coctel de arenque alemán con manzana, cebolla, yogurt, eneldo y pepinillos"),
          it("Plato Amadeus", "Salchicha blanca de ternera, 120 gr. en crudo, con ensalada de papa o col agria y puré de papa. Salchicha hecha en casa"),
          it("Salchicha Viena", "Acompañada con ensalada de papa o ensalada verde. Salchicha de 280 gr. en crudo hecha en casa"),
          it("Salchicha Frankfurt", "Servida con col agria y puré de papa. Salchicha de 225 gr. en crudo hecha en casa"),
          it("Bretzel Gratinado", "Espinacas con champiñones y queso, o queso gruyere, salami y aceitunas"),
          it("Quiche"),
          it("Queso Camembert Frito"),
          it("Currywurst", "Original platillo de Alemania. Salchicha blanca de ternera, 120 gr. en crudo, fileteada y bañada con salsa de jitomate y curry. Salchicha hecha en casa"),
          it("Pasta con Goulash"),
        ],
      },
    ],
  },
  {
    key: "crepas",
    title: "Crepas",
    de: "Pfannkuchen",
    art: A("crepa"),
    groups: [
      {
        title: "Crepas Saladas",
        items: [it("Champiñón"), it("Pollo al Cilantro"), it("Roquefort"), it("Chicharrón con Nopales"), it("Atún")],
      },
      {
        title: "Crepas Dulces",
        items: [
          it("Mango con Rompope"),
          it("Cajeta", "Rellenas con helado de vainilla"),
          it("Amadeus", "Combinación de queso quark con salsa de zarzamora"),
          it("Chocolate"),
          it("Nutella", "Con salsa de vainilla y fresa"),
          it("Manzana con Dulce de Leche"),
        ],
      },
    ],
  },
  {
    key: "postres",
    title: "Postres",
    de: "Nachtisch",
    art: A("pastel"),
    groups: [
      {
        title: "Postres",
        items: [
          it("Rebanada de Pastel"),
          it("Galletas", "6 piezas de galletas surtidas"),
          it("Strudel Vienés de Queso Quark o de Manzana"),
          it("Tartaleta de Frutas"),
          it("Tartaletas Especiales", "Chocolate, queso con blueberry"),
          it("Gelatina con Salsa de Fruta"),
        ],
      },
      {
        title: "Helados y Nieves",
        items: [
          it("Helados y Nieves", "Hechos en casa"),
          it("Banana Split"),
          it("Tres Marías", "Servido con una deliciosa salsa de fresa natural"),
          it("Copa Melba", "Con durazno, helado de vainilla y crema batida"),
          it("Copa Mozart", "Cuatro sabores de helado aderezados con rompope y crema batida"),
          it("Helado de Quark", "Acompañado con salsa de zarzamora y crema batida"),
          it("Copa Tropical", "Nieve de maracuyá, mango y kiwi, servida con papaya, fresa y salsa de mango"),
        ],
      },
    ],
  },
  {
    key: "adicionales",
    title: "Adicionales",
    de: "Beilagen",
    groups: [
      {
        title: "Adicionales",
        items: [
          it("Orden de Arroz con un Huevo"),
          it("Orden de Frijoles o Arroz"),
          it("Orden de Chistorra o Chorizo"),
          it("Orden de Pollo Desmenuzado", "200 gr."),
          it("Orden de Tocino o Jamón"),
          it("Orden de Papas a la Francesa"),
          it("Quesadilla", "Una pieza"),
          it("Orden de Guacamole o Aguacate"),
          it("Pieza de Huevo"),
          it("Pan con Mermelada y Mantequilla"),
        ],
      },
    ],
  },
];
